import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';
import {
	goToNextStep,
	goToPreviousStep,
	getButton,
	setCurrentStep,
	saveButton,
	initializeWizard,
	showLoginModal,
	hideLoginModal,
	hideActionableErroModal,
	hideUnactionableErrorModal,
	destroyForm
} from '../actions/actionsButtonFactory';
import { ProgressMeter } from './progress/ProgressMeter';
import { NavigationHeader } from './navigationHeader/NavigationHeader';
import { ButtonLink } from './buttonLink/ButtonLink';
import WizardStep1 from './WizardStep1';
import WizardStep2 from './WizardStep2';
import WizardStep3 from './WizardStep3';
import WizardStep4 from './WizardStep4';
import { withRouter } from 'react-router-dom';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import PropTypes from 'prop-types'
import { getParameterByName } from '../../utility/queryStringHelper';
import {
	getNextPageUrl,
	getPreviousPageUrl,
	getPageUrl
} from '../utils/buttonFactoryUtils';
import getLocaleMessages from '../utils/localesMessages';
import jQuery from 'jquery';
import * as spinnerUtils from '../utils/spinnerUtils';
import { LoginModal } from './modals/LoginModal';
import { ActionableErrorModal } from './modals/ActionableErrorModal';
import { UnactionableErrorModal } from './modals/UnactionableErrorModal';
import { isLoggedInUser } from '../utils/authUtils';
import * as modalUtils from '../utils/modalUtils';
import { mapServerFieldToClientField } from '../lib/buttonModel';
import { trackWizardDetailsPage } from '../utils/ButtonFactoryFPT';

const {
	progressMeter: {
		stepTitle,
		stepCount
	}
} = getLocaleMessages('buttons/progressMeter');

const {
	navigationHeader,
	back
} = getLocaleMessages('buttons/common');

const {
	actionable
} = getLocaleMessages('buttons/errors')

const mapStateToProps = (state) => {
	const { buttonFactory } = state;

	return {
		buttonFactory,
		initialValues: state.buttonFactory.formattedButton,
		application: state.application,
		form: state.form.buttonFactory
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		goToNextStep,
		goToPreviousStep,
		getButton,
		setCurrentStep,
		saveButton,
		initializeWizard,
		showLoginModal,
		hideLoginModal,
		hideActionableErroModal,
		hideUnactionableErrorModal,
		destroyForm
	}, dispatch);
}

class ButtonFactoryWizard extends Component {
	static propTypes = {
		buttonFactory: PropTypes.object,
		application: PropTypes.object,
		form: PropTypes.object,
		getButton: PropTypes.func,
		saveButton: PropTypes.func,
		goToNextStep: PropTypes.func,
		goToPreviousStep: PropTypes.func,
		setCurrentStep: PropTypes.func,
		initializeWizard: PropTypes.func,
		location: PropTypes.object,
		history: PropTypes.object,
		showLoginModal: PropTypes.func,
		hideLoginModal: PropTypes.func,
		hideActionableErroModal: PropTypes.func,
		hideUnactionableErrorModal: PropTypes.func,
		match: PropTypes.object,
		destroyForm: PropTypes.func
	};

	state = {
		unactionableError: null
	}

	componentDidMount() {
		const isLoggedIn = isLoggedInUser(this.props.application);
		if (isLoggedIn) {
			this.props.hideLoginModal();
		}

		if (this.props.application.isUnsupported) {
			this.handleUnsupportedCountries();
			return;
		}

		const buttonId = _get(this.props, 'match.params.buttonId');

		if (buttonId && buttonId === 'unhosted') {
			this.handleUnhostedButton();
			return;
		}

		if (buttonId) {
			spinnerUtils.showSpinner();
			if (isLoggedIn) {
				this.props.getButton(buttonId)
					.always(() => {
						spinnerUtils.hideSpinner();
					})
			} else {
				spinnerUtils.hideSpinner();
				this.forceUserLogin();
			}
		} else {
			this.initializeWizardComponent();
			spinnerUtils.hideSpinner();
		}

		const currentPage = this.getCurrentPage(this.props) || 1;
		this.props.setCurrentStep(currentPage);
	}

	componentWillReceiveProps(newProps) {
		const currentPage = this.getCurrentPage(newProps);
		if (this.props.buttonFactory.currentStep !== currentPage) {
			this.props.setCurrentStep(currentPage);
		}

		this.overrideLoginBtnFromMarketingHeader();
		this.overrideLogoutBtnFromConsumerHeader();
		setTimeout(() => this.overrideLogoutBtnFromMerchantHeader(), 1000);

		if (window.location.href.indexOf('/login') >= 0) {
			spinnerUtils.showSpinner();
		}
	}

	handleUnhostedButton = () => {
		const { button } = this.props.buttonFactory;
		if (!button) {
			window.location.href = '/donate/buttons';
		} else {
			this.initializeWizardComponent(button);
		}
	}

	initializeWizardComponent = (button) => {
		this.props.initializeWizard(button);
		const currentPage = this.getCurrentPage();
		if (currentPage !== 1) {
			this.goToFirstStep();
		}
	}

	handleUnsupportedCountries = () => {
		const countryNotAllowed = {
			name: 'COUNTRY_NOT_ALLOWED',
			message: 'Country not allowed for button creation.'
		}

		this.setState({
			unactionableError: countryNotAllowed
		}, () => {
			modalUtils.showUnactionableErrorModal();
			let wizard = document.getElementById('button-factory-wizard');
			wizard.parentNode.removeChild(wizard);
			spinnerUtils.hideSpinner();
		});

		return;
	}

	forceUserLogin() {
		const current_location = window.location.href;
		const returnUri = current_location.substr(current_location.indexOf('/buttons'));
		const renderURL = '/donate/buttons/login?returnUri=' + returnUri;
		this.props.history.push(renderURL);
		location.reload();
	}

	overrideLoginBtnFromMarketingHeader() {
		const state = this.props && this.props.form ? jQuery.param(this.props.form.values) : '';
		let loginBtn = jQuery('.header-buttons a[href="/signin"]');
		loginBtn = loginBtn && loginBtn.get(0);

		if (loginBtn) {
			loginBtn.addEventListener('click', (event) => {
				event.preventDefault();
				const renderURL = '/donate/buttons/login?returnUri=/buttons?' + state;
				this.props.history.push(renderURL);
				location.reload();
			});
		}
	}

	overrideLogoutBtnFromConsumerHeader() {
		let logoutBtn = document.getElementById('header-logout');
		if (logoutBtn) {
			logoutBtn.href = '/signout?returnUri=/donate/buttons'
		}
	}

	overrideLogoutBtnFromMerchantHeader() {
		jQuery('document').ready(function() {
			if (document.getElementsByClassName('css-1qqoygz').length > 0) {
				let logoutBtn = document.getElementsByClassName('css-1qqoygz')[0];
				if (logoutBtn) {
					logoutBtn.href = '/signout?returnUri=/donate/buttons'
				}
			}
		});
	}

	getApplicationValues = (key) => {
		return _get(this.props.application, key);
	}

	renderWizardStep = () => {
		const isLoggedIn = isLoggedInUser(this.props.application);
		const isHosted = _includes(['BUSINESS', 'PREMIER'], this.getApplicationValues('userType'));
		const { buttonFactory } = this.props;

		switch (buttonFactory.currentStep) {
			case 1: return (
				<WizardStep1
					onSubmit={this.handleContinueClick}
					buttonFactory={this.props.buttonFactory}
					history={this.props.history}
				/>
			)
			case 2: return (
				<WizardStep2
					onSubmit={this.handleContinueClick}
				/>
			)
			case 3: return (
				<WizardStep3
					onSubmit={isLoggedIn && isHosted ? this.handleContinueClick : this.handleWizardFormSubmit}
				/>
			)

			case 4: return (
				<WizardStep4
					onSubmit={this.handleWizardFormSubmit}
					buttonFactory={this.props.buttonFactory}
				/>
			)

			default: return null;
		}
	}

	goToFirstStep = () => {
		const currentPath = this.props.location.pathname;
		this.props.history.replace(`${currentPath}?page=1`);
	}

	handleBackClick = (event) => {
		const currentPath = this.props.location.pathname;
		this.props.history.push(getPreviousPageUrl(this.getCurrentPage(this.props), currentPath));
		event.preventDefault(); // This does not put # in the URL
	}

	getCurrentPage = (props) => {
		return Number(getParameterByName('page')) || 1;
	}

	handleContinueClick = () => {
		const currentPath = this.props.location.pathname;
		this.props.history.push(getNextPageUrl(this.getCurrentPage(this.props), currentPath));
		this.props.goToNextStep();
	}

	handleWizardFormSubmit = (buttonData) => {
		// Clear errors on submit
		this.setState({
			unactionableError: null
		})
		spinnerUtils.showSpinner();

		const isDuplicating = !(this.props.match.path.indexOf('/duplicate') === -1);
		const isEditing = !(this.props.match.path.indexOf('/edit') === -1);

		if (isDuplicating) {
			delete buttonData.id;
		} else if (isEditing) {
			buttonData.id = this.props.buttonFactory.button.id;
		}

		return new Promise((resolve, reject) => {
			this.props.saveButton(buttonData)
				.then((response) => {
					const buttonId = _get(response, 'button.id');
					if (buttonId) {
						this.props.history.push(`/donate/buttons/${buttonId}`);
						
						trackWizardDetailsPage({
							button_id: buttonId,
							hosted_button_id: buttonId
						})
					} else {
						const receiverCountry = _get(response, 'data.clientData.userData.legalCountry');
						trackWizardDetailsPage({
							rcvrcntry: receiverCountry
						})
						
						this.props.history.push('/donate/buttons/unhosted');
					}
					// destroy form
					// We use `destroyOnUnmount: false` which causes redux-form to save values
					// after unmount. So, manually destroy the form to clear values
					this.props.destroyForm();
				})
				.fail((error) => {
					const errObj = this.handleServerSideError(_get(error, 'responseJSON.button'));

					if (errObj) {
						reject(new SubmissionError(errObj));
					}
				})
				.always(() => {
					spinnerUtils.hideSpinner();
				});
		})
	}

	handleServerSideError = (error) => {
		if (error) {
			switch (error.name) {
				case 'VALIDATION':
					const errField = _get(error, 'details[0].field');
					const errMsg = this.getErrorMsg(errField);
					const clientFieldName = mapServerFieldToClientField(errField);

					let errObj = {};
					errObj[clientFieldName] = errMsg;

					modalUtils.showActionableErrorModal(errMsg);
					this.jumpToErrorPage(clientFieldName);
					return errObj;

				case 'COUNTRY_NOT_ALLOWED':
					let wizard = document.getElementById('button-factory-wizard');
					wizard.parentNode.removeChild(wizard);
					let marketingFooter = document.getElementsByClassName('global-footer')[0];
					if (marketingFooter) {
						marketingFooter.setAttribute('style', 'position: absolute; bottom: 0px; width: 100%; top: inherit');
					}

				default: // eslint-disable-line
					this.setState({
						unactionableError: error
					}, () => {
						modalUtils.showUnactionableErrorModal();
					});
					return;
			}
		} else {
			modalUtils.showUnactionableErrorModal();
			return;
		}
	}

	jumpToErrorPage = (field) => {
		const currentPath = this.props.location.pathname;
		let targetPage = 1;

		switch (field) {
			case 'logoUrl':
			case 'business':
			case 'purpose':
			case 'itemNumber':
				targetPage = 2;
				break;

			case 'currencyCode':
			case 'amountType':
			case 'amountValue':
				targetPage = 3;
				break;

			case 'cancelReturn':
			case 'return':
			case 'extraVariablesView':
				targetPage = 4;
				break;

			default:
				break;
		}

		this.props.history.push(getPageUrl(targetPage, currentPath));
	}

	getErrorMsg = (field) => {
		if (actionable[field]) {
			return actionable[field];
		}
		return actionable.default;
	}

	closeLoginModal = () => {
		this.props.hideLoginModal();
	}

	handleModalLogin = () => {
		const renderURL = '/donate/buttons/login?returnUri=/buttons';
		this.props.history.push(renderURL);
		this.props.hideLoginModal();
		location.reload();
	}

	closeActionableErrorModal = () => {
		this.props.hideActionableErroModal();
	}

	closeUnactionableErrorModal = () => {
		modalUtils.hideUnactionableErrorModal();
		this.setState({
			error: null
		})
	}

	startOver() {
		modalUtils.hideActionableErroModal();
		spinnerUtils.showSpinner();
		window.location.href = '/donate/buttons';
	}

	getStepTitle = (currentStep) => {
		if (currentStep === 2) {
			const isBusinessAccount = _includes(['BUSINESS'], this.getApplicationValues('userType'));
			let title = isBusinessAccount ? stepTitle['2'] : stepTitle['2A'];
			// If stepTitle['2A'] is not translated, show stepTitle['2']
			title = title || stepTitle['2'];
			return title;
		}

		return stepTitle[currentStep];
	}

	render() {
		const {
			currentStep,
			totalSteps,
			busy
		} = this.props.buttonFactory;

		const stepsString = stepCount
			.replace(new RegExp('{currentStep}'), currentStep)
			.replace(new RegExp('{totalSteps}'), totalSteps);

		return (
			<div>
				<div className="button-factory-wizard" id="button-factory-wizard">
					<div className="content">
						<div className="button-factory-progress-indicator">
							<ProgressMeter
								currentStep={currentStep}
								totalSteps={totalSteps}
								stepTitle={this.getStepTitle(currentStep)}
								stepCount={stepsString}
							/>
						</div>
						{this.props.buttonFactory.currentStep > 1 &&
							<div className="back-button-container">
								<span className="vx_icon vx_icon-arrow-left-small vx_icon-default" />
								<ButtonLink text={back} onClick={this.handleBackClick} />
							</div>
						}
						<div className="button-factory-body">
							<div className="button-factory-header">
								<NavigationHeader
									headerContent={navigationHeader.header}
									isMobile={this.props.application.isMobile}
								/>
							</div>
							{!busy && this.renderWizardStep()}
						</div>
					</div>
				</div>

				<LoginModal
					buttonFactory={this.props.buttonFactory}
					closeModal={this.closeLoginModal}
					handleLogin={this.handleModalLogin}
				/>

				<ActionableErrorModal
					buttonFactory={this.props.buttonFactory}
					closeModal={this.closeActionableErrorModal}
					startOver={this.startOver}
				/>

				<UnactionableErrorModal
					closeModal={this.closeUnactionableErrorModal}
					startOver={this.startOver}
					error={this.state.unactionableError}
				/>
			</div>
		);
	}
}

const ButtonFactoryWizardForm = connect(mapStateToProps, mapDispatchToProps)(ButtonFactoryWizard)
export default withRouter(ButtonFactoryWizardForm);



// WEBPACK FOOTER //
// ./buttons/components/ButtonFactoryWizard.js